import { render, staticRenderFns } from "./OfferTemplateImportDialog.vue?vue&type=template&id=20b1d0fa&scoped=true"
import script from "./OfferTemplateImportDialog.vue?vue&type=script&lang=js"
export * from "./OfferTemplateImportDialog.vue?vue&type=script&lang=js"
import style0 from "./OfferTemplateImportDialog.vue?vue&type=style&index=0&id=20b1d0fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b1d0fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})


/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Intersect from 'vuetify/lib/directives/intersect'
installDirectives(component, {Intersect})
